import { motion } from 'motion/react';
import styled from 'styled-components';

export const Prompt = styled(motion.div)`
  position: fixed;
  right: 24px;
  bottom: 24px;
  /* Just below the toast stack (999999): a transient toast may briefly pass over this one. */
  z-index: 999998;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 360px;
  max-width: calc(100vw - 24px);
  padding: 14px;
  border-radius: 14px;
  border: 1px solid var(--border-color);
  background: var(--card-background);
  box-shadow:
    0 12px 32px -12px rgba(16, 24, 40, 0.28),
    0 2px 6px -2px rgba(16, 24, 40, 0.12);
  color: var(--main-black);

  [data-theme='dark'] & {
    box-shadow: 0 12px 32px -10px rgba(0, 0, 0, 0.55);
  }

  /* Above the mobile tab bar, and clear of the home indicator. */
  @media (max-width: 768px) {
    left: 12px;
    right: 12px;
    bottom: calc(76px + env(safe-area-inset-bottom, 0px));
    width: auto;
    max-width: none;
  }
`;

export const Body = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

export const Message = styled.p`
  font-size: var(--font-size-medium);
  line-height: 1.45;
  overflow-wrap: anywhere;
`;

export const UpdateButton = styled.button`
  padding: 7px 14px;
  border: 0;
  border-radius: 8px;
  background: var(--main-black);
  color: var(--main-white);
  font-size: var(--font-size-small);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    opacity: var(--hover-opacity);
  }
`;

export const Close = styled.button`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-tertiary);
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    background: var(--hover-background);
    color: var(--main-black);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
